<div class="ribbon-banner">
  <om-svg-gift-box-icon *ngIf="icon" class="icon"></om-svg-gift-box-icon>
  <span class="cta">{{ text }}</span>
  <div class="btn btn-primary" (click)="ctaAction()">{{ cta }}</div>
</div>
